(function () {

    function loadScript(src, cb) {
        var s = document.createElement('script');
        s.async = true;
        s.src = src;
        s.onload = cb || null;
        document.head.appendChild(s);
    }

    function loadGA4() {
        if (window.gaLoaded) return;
        window.gaLoaded = true;

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { dataLayer.push(arguments) };

        loadScript(
            "https://www.googletagmanager.com/gtag/js?id=GT-PLHC8P28",
            function () {
                gtag('js', new Date());
                gtag('config', 'GT-PLHC8P28');
                console.log('GA4 loaded');
            }
        );
    }

    function loadGTM() {
        if (window.gtmLoaded) return;
        window.gtmLoaded = true;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gtm.js',
            'gtm.start': new Date().getTime()
        });

        loadScript(
            "https://www.googletagmanager.com/gtm.js?id=GTM-5DV8KWX5"
        );

        console.log('GTM loaded');
    }

    function loadKlaviyo() {
        if (window.klaviyoLoaded) return;
        window.klaviyoLoaded = true;

        window._learnq = window._learnq || [];

        loadScript(
            "https://static.klaviyo.com/onsite/js/X362dY/klaviyo.js?company_id=X362dY"
        );

        console.log('Klaviyo loaded');
    }

    function checkConsent() {

        if (!window.Pandectes || !window.Pandectes.consent) return;

        var consent = window.Pandectes.consent;

        if (consent.analytics) {
            loadGA4();
        }

        if (consent.marketing) {
            loadGTM();
            loadKlaviyo();
        }
    }

    setTimeout(checkConsent, 2000);
    document.addEventListener('pandectes:consent', checkConsent);

})();